export const STRIPE_CLIENT_BETAS = [
    'payment_element_beta_2',
    'alipay_pm_beta_1',
    'link_default_integration_beta_1',
    'shipping_address_element_beta_1',
    'address_element_beta_1',
];

export const STRIPE_CLIENT_API_VERSION = '2020-03-02;alipay_beta=v1;link_beta=v1';
